export default "__VITE_ASSET__CHrMkNhx__"